import { Col, Row } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { PaymentInstrument } from "../../../generated";

const getCardType = (cardType: string) => {
  switch (cardType) {
    case "001":
      return "visa";
    case "002":
      return "master-card";
    case "003":
      return "american-express";
    case "004":
      return "discover";
  }
};

const maskAndFormatCardNumber = (cardNumber: string, cardType: string) => {
  // Check if the card is an Amex card (15 digits)
  const isAmex = cardType === "003";

  // Mask all digits except the last four
  const maskedCardNumber =
    cardNumber.slice(0, -4).replace(/\d/g, "X") + cardNumber.slice(-4);

  // Add hyphens for readability
  let formattedCardNumber;
  if (isAmex) {
    // Format Amex card: XXXX XXXXXX XXXXX
    formattedCardNumber = maskedCardNumber.replace(
      /(.{4})(.{6})(.{5})/,
      "$1-$2-$3"
    );
  } else {
    // Format regular cards: XXXX XXXX XXXX XXXX
    formattedCardNumber = maskedCardNumber
      .replace(/(.{4})/g, "$1-")
      .slice(0, -1);
  }

  return formattedCardNumber;
};

interface PaymentInstrumentDisplayProps {
  paymentInstrument: PaymentInstrument;
  actionButton: React.ReactNode;
}

export const PaymentInstrumentDisplay: React.FC<
  PaymentInstrumentDisplayProps
> = ({ paymentInstrument, actionButton }) => {
  const isExpired =
    Number(paymentInstrument?.expirationMonth) <= dayjs().month() &&
    Number(paymentInstrument?.expirationYear) <= dayjs().year();

  if (paymentInstrument?.cardNumber && paymentInstrument?.cardType) {
    return (
      <Row gutter={[30, 16]} align="middle">
        <Col>
          {paymentInstrument?.cardType && (
            <div className="p-1 rounded-md border-[1px] border-solid border-neutral-200">
              <img
                src={`/card-images/${getCardType(paymentInstrument.cardType)}.svg`}
                alt={`${paymentInstrument.cardType} logo`}
                className="w-8 border border-black p-0 m-0"
              />
            </div>
          )}
        </Col>

        <Col>
          <span className="w-44">
            {maskAndFormatCardNumber(
              paymentInstrument.cardNumber,
              paymentInstrument.cardType
            )}
          </span>
        </Col>

        {/* EXPIRATION DATE */}
        <Col>
          {isExpired && (
            <ExclamationCircleOutlined className="mr-1 text-red-500" />
          )}
          <span className={isExpired ? "text-red-500" : ""}>
            exp&nbsp;
            {paymentInstrument.expirationMonth}/
            {paymentInstrument.expirationYear}
          </span>
        </Col>

        {/* ACTIONS */}
        <Col>{actionButton}</Col>
      </Row>
    );
  }

  return null;
};
